<template>
  <div
    v-if="isBannerVisible"
    class="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center overflow-none"
  >
    <div class="relative px-3 md:px-0 md:w-3/5">
      <div
        @click.stop="closeBanner"
        class="absolute right-0 -mt-8 md:-mt-4 mr-2 md:-mr-4 inline-flex rounded-full p-2 bg-white cursor-pointer"
      >
        <i class="material-icons">close</i>
      </div>
      <a href="https://thebuyhive.com/panel-discussion-3?utm_medium=website&utm_source=popup_box&utm_campaign=160321">
        <img src="@/assets/images/covidBanner3.jpg">
      </a>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import moment from 'moment-timezone'

const covidBannerShowed = 'buyhive_covidBannerShowed'

export default {
  name: 'CovidBanner',
  data() {
    return {
      isBannerVisible: false
    }
  },
  created() {
    this.showBanner()
  },
  methods: {
    showBanner() {
      const dateTime = moment().tz("Asia/Hong_Kong")
      const hour = dateTime.hour()
      const date = dateTime.date()
      const month = dateTime.month()
      const year = dateTime.year()

      const alreadyShowed = Cookies.get(covidBannerShowed) === 'true'

      if (!alreadyShowed && (year < 2022) && (month < 3) && (date < 17)) {
        if (date === 16 && hour >= 10) return
        setTimeout(()=> {
          this.isBannerVisible = true
        }, 3000)
      }
    },
    closeBanner() {
      this.isBannerVisible = false
      Cookies.set(covidBannerShowed, 'true')
    }
  }
}
</script>
